import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { Router } from './Router';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

// here the order is very important! tailwind will override some of the mantine styles
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/charts/styles.css';
import './styles/tailwind.css';
import 'dayjs/locale/cs';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';

// TODO: move it to (date-)config file
dayjs.extend(customParseFormat);
export const dateFormat: string = 'YYYY-MM-DD';
export const dateTimeFormat: string = 'YYYY-MM-DD HH:mm:ss';
export const locale: string = 'cs';

export const dateFormatUI: string = 'DD.MM.YYYY';
export const dateTimeFormatUI: string = 'DD.MM.YYYY HH:mm:ss';

if (typeof document !== 'undefined') {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);

    root.render(
      // Synchronize mantine's global theme font with tailwind's
      <MantineProvider
        theme={{
          fontFamily: getComputedStyle(document.body).fontFamily,
        }}
      >
        <ModalsProvider>
          <Notifications position="top-right" />
          <Router />
        </ModalsProvider>
      </MantineProvider>
    );
  }
}
